// extracted by mini-css-extract-plugin
export default {"backButtonImg":"DetailLayout_backButtonImg__1d8JU","backButton":"DetailLayout_backButton__m4IJZ"};